import { render } from "./ServiceTpl.vue?vue&type=template&id=7e5c2d1b"
import script from "./ServiceTpl.vue?vue&type=script&lang=js"
export * from "./ServiceTpl.vue?vue&type=script&lang=js"

import "./ServiceTpl.vue?vue&type=style&index=0&id=7e5c2d1b&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__